import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum RelationStatusEnum {
    Alive = 1 as any,
    Deceased = 2 as any
}
class RelationStatusClass extends EnumWithDescription<RelationStatusEnum> {
    public readonly enum = RelationStatusEnum;
    public readonly enumName: string = "RelationStatusEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<RelationStatusEnum>> = new Map([
        [
            "Alive",
            {
                value: RelationStatusEnum.Alive,
                name: "Alive"
            }
        ],
        [
            "Deceased",
            {
                value: RelationStatusEnum.Deceased,
                name: "Deceased"
            }
        ]
    ]);
}

export const RelationStatus = new RelationStatusClass();
